import type { CorreoEventoTipo } from '../../../model/kartera-api-model'

export { errorMessage, formatCount, pageWindow } from '../../customers/common/customer-common'

export const EMAIL_TEMPLATES_PATH = '/configuracion/modelos'
export const EMAIL_TEMPLATES_BACK_PATH = '/configuracion'
export const NEW_EMAIL_TEMPLATE_PATH = `${EMAIL_TEMPLATES_PATH}/nuevo`

export const emailTemplatePath = (id: number) => `${EMAIL_TEMPLATES_PATH}/${id}`

export const EVENT_TONES: Record<CorreoEventoTipo, string> = {
    cxc_primer_recibo: 'bg-tone-teal text-tone-teal-ink',
    cxc_recibo_subsecuente: 'bg-tone-blue text-tone-blue-ink',
    renovacion_poliza: 'bg-tone-orange text-tone-orange-ink',
    entrega_poliza: 'bg-tone-purple text-tone-purple-ink',
}

export const eventTone = (tipo?: CorreoEventoTipo | null) => (tipo && EVENT_TONES[tipo]) || 'bg-k-accent-soft text-k-accent-ink'

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}
